import { formValueSelector } from 'redux-form';
import { AppState } from 'store';
import {
  PropertyFormPlaceholders,
  PROPERTY_SEARCH_FORM,
  EMPTY_VALUE,
  SearchTypeFormNames,
} from './PropertySearch.constants';
import { GetDriversResult, PropertySearchResult } from './models';
import { Cities, Counties, USState } from 'common/models';

type LocationsType = {
  name: string;
  hobCode: string;
}[];

export const usStateSelector = ({
  propertySearch: { usState },
}: AppState): USState => usState;

export const resultSelector = ({
  propertySearch: { result },
}: AppState): PropertySearchResult => result;

export const driversSelector = ({
  propertySearch: { driversData },
}: AppState): GetDriversResult => driversData;

export const detailsSelector = ({
  propertySearchDetails: { details },
}: AppState) => details;

export const detailsLoadingSelector = ({
  propertySearchDetails: { loading },
}: AppState) => loading;

export const valueSelector = (state: AppState, fieldName: string) =>
  formValueSelector(PROPERTY_SEARCH_FORM)(state, fieldName);

export const getCities = (counties: Counties, countyHob: string) => {
  const county = counties.find(({ hobCode }) => hobCode === countyHob);
  return county ? county.cities : null;
};

const getPlaceHolder = (text: string) => [
  {
    value: EMPTY_VALUE,
    text,
  },
];

const getOptions = (locations: LocationsType) =>
  locations.map(({ name: text, hobCode: value }) => ({ value, text }));

export const getCountyOptions = (counties: Counties) => [
  ...getPlaceHolder(PropertyFormPlaceholders.COUNTY),
  ...getOptions(counties),
];

export const getCityOptions = (counties: Counties, countyHob: string) => {
  const placeHolder = getPlaceHolder(PropertyFormPlaceholders.CITY);
  if (counties && counties.length && countyHob) {
    const county = counties.find(({ hobCode }) => hobCode === countyHob);
    return county && county.cities.length
      ? [...placeHolder, ...getOptions(county.cities)]
      : placeHolder;
  }
  return placeHolder;
};

export const getVillageOptions = (cities: Cities | null, cityHob: string) => {
  const placeHolder = getPlaceHolder(PropertyFormPlaceholders.VILLAGE);
  if (cities && cities.length && cityHob) {
    const city = cities.find(({ hobCode }) => hobCode === cityHob);
    return city && city.villages.length
      ? [...placeHolder, ...getOptions(city.villages)]
      : placeHolder;
  }
  return placeHolder;
};

export const getHobCode = ({ countyHob, cityHob, villageHob }: any) =>
  villageHob || cityHob || countyHob || EMPTY_VALUE;

export const searchByAddressBody = ({
  [SearchTypeFormNames.ADDRES_SEARCH]: {
    streetNumber = EMPTY_VALUE,
    streetName = EMPTY_VALUE,
  },
  hobCodes,
}: any) => {
  const hobCode = getHobCode(hobCodes);
  return {
    streetNumber,
    streetName,
    hob: hobCode,
  };
};

export const searchByOwnerBody = ({
  [SearchTypeFormNames.OWNER_SEARCH]: {
    firstName = EMPTY_VALUE,
    lastName = EMPTY_VALUE,
    corporationName = EMPTY_VALUE,
  },
  hobCodes,
}: any) => {
  const hobCode = getHobCode(hobCodes);
  return {
    firstName,
    lastName,
    corporationName,
    hob: hobCode,
  };
};
